import { cairoPageCtaClickedParams } from '@wix/bex-utils/@wix/bi-logger-os-data/v2/types';
import { TranslationsKeys } from '../services';

export type SaveCtaText =
  | 'PUBLISH'
  | 'APPLY'
  | 'CONNECT'
  | 'ACTIVATE'
  | 'SAVE'
  | 'SUBMIT';

export const ctaKeys: Record<SaveCtaText, TranslationsKeys> = {
  PUBLISH: 'cairo.entityPage.header.publish.CTA',
  APPLY: 'cairo.entityPage.header.apply.CTA',
  CONNECT: 'cairo.entityPage.header.connect.CTA',
  ACTIVATE: 'cairo.entityPage.header.activate.CTA',
  SAVE: 'cairo.entityPage.header.save.CTA',
  SUBMIT: 'cairo.entityPage.header.submit.CTA',
};

export interface ActionsBarConfig {
  saveCta?: {
    text?: SaveCtaText;
    biAdditionalInfo?: cairoPageCtaClickedParams['additionalInfo'];
  };
  cancelCta?: {
    biAdditionalInfo?: cairoPageCtaClickedParams['additionalInfo'];
  };
}
